var _line, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesktopAroundScmpPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 1208,
  height: 1229,
  viewBox: "0 0 1208 1229",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 1208,
  y1: 1.37012,
  x2: -4.37115e-8,
  y2: 1.37001,
  stroke: "black"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  y: 16.8701,
  width: 268,
  height: 23,
  fill: "#E5E5E5"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  y: 63.8701,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  y: 85.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  y: 241.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 308.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  y: 375.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 63.8701,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 85.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 241.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 308.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 375.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 63.8701,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 85.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 241.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 308.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 375.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 63.8701,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 85.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 241.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 308.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 375.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 63.8701,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 85.8701,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 241.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 308.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 375.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
  y: 462.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
  y: 484.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
  y: 640.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
  y: 707.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
  y: 774.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 462.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 484.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 640.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 707.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 774.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 462.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 484.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 640.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 707.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 774.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 462.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 484.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 640.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 707.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 774.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 462.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 484.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 640.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 707.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 774.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
  y: 861.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
  y: 883.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
  y: 1039.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
  y: 1106.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
  y: 1173.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 861.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 883.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 1039.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 1106.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
  x: 248,
  y: 1173.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 861.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 883.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 1039.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 1106.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
  x: 496,
  y: 1173.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 861.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 883.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 1039.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 1106.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
  x: 744,
  y: 1173.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 861.87,
  width: 216,
  height: 10,
  fill: "#E5E5E5"
})), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 883.87,
  width: 216,
  height: 144,
  fill: "#E5E5E5"
})), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 1039.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 1106.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
  x: 992,
  y: 1173.87,
  width: 216,
  height: 55,
  fill: "#E5E5E5"
})));
export default SvgDesktopAroundScmpPlaceholder;